import { normalizeUri } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
import { InstagramMediaTypes } from '../constants';
export function toItem(data) {
  const isVideo = data.media_type === InstagramMediaTypes.VIDEO;
  const mediaType = isVideo ? MediaType.Video : MediaType.Picture;
  return {
    id: data.id,
    name: data.caption,
    kind: ItemKind.File,
    source: 'instagram',
    mediaType,
    fileUrl: data.media_url,
    thumbnailUrl: normalizeUri(isVideo ? data.thumbnail_url : data.media_url),
    previewUrl: normalizeUri(data.media_url)
  };
}